import { Box, Grid } from "@mui/material";
import TableOne from "./components/TableOne";
import TableTwo from "./components/TableTwo";
import TableThree from "./components/TableThree";
import TableFour from "./components/TableFour";

interface MaintenanceProps {
    highlighting: boolean;
    dateRange: [Date | undefined, Date | undefined];
    currentArea: string;
    currentSubArea: string | null;
    filterSmallValues: boolean
    
}
function Maintenance({highlighting,dateRange,currentArea,currentSubArea,filterSmallValues}:MaintenanceProps) {
  return (
      <Grid container spacing={2}>
        <Grid  item xs={6}>
      <TableOne
      highlighting={highlighting}
      dateRange={dateRange}
          currentArea={currentArea}
          currentSubArea={currentSubArea}
          filterSmallValues={filterSmallValues} />
        </Grid>
        <Grid item xs={6}>
      <TableTwo  highlighting={highlighting}
      dateRange={dateRange}
          currentArea={currentArea}
          currentSubArea={currentSubArea}
          filterSmallValues={filterSmallValues} />
          </Grid>
          <Grid item xs={6}>
            <TableThree highlighting={highlighting}
      dateRange={dateRange}
          currentArea={currentArea}
          currentSubArea={currentSubArea}
          filterSmallValues={filterSmallValues} />
          </Grid>
          <Grid item xs={12}>
            <TableFour highlighting={highlighting}
      dateRange={dateRange}
          currentArea={currentArea}
          currentSubArea={currentSubArea}
          filterSmallValues={filterSmallValues} />
          </Grid>
      </Grid>
  )
}

export default Maintenance